export default __webpack_public_path__ + "static/icon-18-3-662cbc326c9b720fbf5002d0f304b998.png";